
export default () => {
  document.querySelectorAll(".js-toc").forEach((container, i) => {
    const toggleButton = container.querySelector(".js-toggle-toc");
    const tocList = container.querySelector(".js-toc-list");

    if (!toggleButton || !tocList) return;

    toggleButton.addEventListener("click", (e) => {
        e.preventDefault();
        tocList.classList.toggle("is-expanded");

        // Show all topic-listing__list elements when toggling
        const allListSections = document.querySelectorAll('.topic-listing__list');
        allListSections.forEach(section => {
            section.style.display = 'block';
        });
    });

     // Smooth scroll behavior for TOC letter links
        const tocLinks = document.querySelectorAll(".js-toc-link");

        tocLinks.forEach((link) => {
            link.addEventListener("click", function (e) {
            const targetId = this.getAttribute("href").substring(1); // Remove #
            const targetEl = document.getElementById(targetId);

              if (targetEl) {
                e.preventDefault();
                
                // Hide all topic-listing__list elements that don't contain the targetId
                const allListSections = document.querySelectorAll('.topic-listing__list');
                allListSections.forEach(section => {
                    const letterElement = section.querySelector('.topic-listing__list-letter');
                    if (letterElement && letterElement.id !== targetId) {
                        section.style.display = 'none';
                    } else {
                        section.style.display = '';
                    }
                });
                
                // Optionally update the hash in URL
                history.pushState(null, null, `#${targetId}`);
              }
            });
        });
  });
};
